import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const eccoTheme = createTheme({
  palette: {
    primary: {
      main: "#2e5d7a",
    },
    secondary: {
      main: "#398f56",
    },
    error: {
      main: "#d9534f",
    },
  },
  typography: {
    fontFamily: "Lexend",
  },
});

const ecubeTheme = createTheme({
  palette: {
    primary: {
      main: "#008aca",
    },
    secondary: {
      main: "#fed800",
    },
    error: {
      main: "#d9534f",
    },
  },
  typography: {
    fontFamily: "Lexend",
  },
});

const themes = {
  ecco: responsiveFontSizes(eccoTheme),
  ecube: responsiveFontSizes(ecubeTheme),
};

export default themes;
